'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from '@react-three/drei';
import { useFrame, useThree } from '@react-three/fiber';
import { useXR } from '@react-three/xr';
import { useRef, useSyncExternalStore } from 'react';
import { BackSide } from 'three';
import { initialXrSceneFade, stepXrSceneFade } from '../_pure/xrSceneFade.js';
/**
 * Covers the headset while the host swaps scenes, so the viewer never sees an empty world or the jump
 * to the next scene's arrival pose. Rendered inside the XR origin so it moves with the rig.
 */
export default function XrSceneFade({ slot }) {
    const head = useThree((state) => state.gl.xr.getCamera());
    const session = useXR((state) => state.session);
    const loading = !useSyncExternalStore(slot.subscribe, slot.active, slot.active);
    const groupRef = useRef(null);
    const materialRef = useRef(null);
    const fade = useRef(initialXrSceneFade(slot.owner()));
    useFrame((_, delta) => {
        fade.current = stepXrSceneFade(fade.current, slot.owner(), delta);
        const group = groupRef.current;
        if (!group || !materialRef.current)
            return;
        group.position.copy(head.position);
        group.quaternion.copy(head.quaternion);
        group.visible = fade.current.opacity > 0;
        materialRef.current.opacity = fade.current.opacity;
    });
    if (!session)
        return null;
    return _jsxs("group", { ref: groupRef, children: [_jsxs("mesh", { renderOrder: 20000, children: [_jsx("sphereGeometry", { args: [0.5, 16, 12] }), _jsx("meshBasicMaterial", { ref: materialRef, color: "black", side: BackSide, transparent: true, depthTest: false, depthWrite: false })] }), loading ? _jsx(Text, { position: [0, 0, -0.45], fontSize: 0.03, color: "#c8d6e5", anchorX: "center", anchorY: "middle", renderOrder: 20001, "material-depthTest": false, children: "Loading\u2026" }) : null] });
}
